import React from "react"
import { motion } from "framer-motion"
import animations from "./animations"

export default function Drone({ controls }) {
  const { mainSequence } = animations
  return (
    <motion.g
      initial={{ opacity: 0, scaleY: 0 }}
      animate={controls}
      variants={mainSequence.drone.droneX}
    >
      <motion.g animate={controls} variants={mainSequence.drone.droneY}>
        <path
          fill="url(#drone-body)"
          d="M239.3,111.2c0.1,0.1,0.2,0.2,0.2,0.3v0.9c0,0.2-0.3,0.4-0.7,0.4l-7.8,0.5c-1.6,0.1-2.9,0.8-3.1,1.8l-0.8,4.5
            c0,0.2-0.4,0.4-0.8,0.4h-1.5c-0.2,0-0.4,0-0.5-0.1s-0.2-0.2-0.2-0.3l-0.8-4.5c-0.1-0.5-0.5-0.9-1-1.2c-0.6-0.3-1.3-0.5-2.1-0.6
            l-7.8-0.5c-0.2,0-0.3-0.1-0.5-0.1c-0.1-0.1-0.2-0.2-0.2-0.3v-0.9c0-0.2,0.3-0.4,0.7-0.4l7.8-0.5c1.6-0.1,2.9-0.8,3.1-1.8l0.8-4.5
            c0-0.2,0.4-0.4,0.8-0.4h1.5c0.2,0,0.4,0,0.5,0.1s0.2,0.2,0.2,0.3l0.8,4.5c0.1,0.5,0.5,0.9,1,1.2c0.6,0.3,1.3,0.5,2.1,0.6l7.8,0.5
            C239,111.1,239.2,111.1,239.3,111.2z"
        />

        {/* MAP DRONE ROTOR BLADES */}
        {[
          { x: 0, y: 0 },
          { x: 0, y: 15 },
          { x: 13, y: 8 },
          { x: -13, y: 8 },
        ].map((node, index) => (
          <DroneBlades key={index} x={node.x} y={node.y} />
        ))}
      </motion.g>
    </motion.g>
  )
}

function DroneBlades({ x, y }) {
  return (
    <motion.g
      initial={{
        x: x,
        y: y,
        rotateX: "60deg",
      }}
      animate={{
        rotateZ: ["0deg", "360deg"],
      }}
      transition={{
        duration: 0.25,
        ease: "linear",
        repeat: Infinity,
      }}
    >
      <path
        fill="url(#drone-blade-1)"
        d="M225.4,102.7c-0.7,0-2.4,1.7-3.4,2.8c-1.1,1.3-1.7,2.8-1.3,3.2s1.6-0.2,2.7-1.7c1-1.3,2.2-3.5,2.3-4.3H225.4z"
      />
      <path
        fill="url(#drone-blade-2)"
        d="M230.4,96.8c-0.4-0.4-1.6,0.2-2.7,1.7c-1,1.3-2.2,3.5-2.3,4.3l0,0l0.3,0.4c0.7,0,2.4-1.7,3.4-2.8
          C230.2,98.8,230.8,97.3,230.4,96.8z"
      />
      <ellipse
        opacity="0.05"
        fill="#4FC3F5"
        cx="225.6"
        cy="102.9"
        rx="7.8"
        ry="7.8"
      />
    </motion.g>
  )
}
